/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import CloseIcon from '@mui/icons-material/Close';
import {IconButton, Typography} from "@mui/material";
import {REDLINE_DIALOG_OPTIONS, TREE_OPERATIONS} from "../../../pages/CoverageRequirements/ItemDetails/constants";
import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import {StyledArgosDialog} from "../ArgosDialog";
import ArgosDialogHeader from "../ArgosDialogHeader";
import AddNewDatasetDialogContent from "./AddNewDatasetDialogContent";
import AddNewFolderDialogContent from "./AddNewFolderDialogContent";
import AddPropertyDialog from "./AddPropertyDialog";
import DeleteCategoryGroup from "./DeleteCategoryGroupDialog";
import DeleteFolderDialogContent from "./DeleteFolderDialogContent";
import DuplicateDatasetDialog from "./DuplicateDatasetDialog";
import {EditDrivingScenarioRowDialog} from "./EditDrivingScenarioRowDialog";
import EditMergeSet from "./EditMergeSet";
import EditPropertyDialog from "./EditPropertyDialog";

const RedlineAppDialog = (props: any) => {
  const generateDialogBasedOnType = () => {
    switch (props.dialogtype) {
      case REDLINE_DIALOG_OPTIONS.DEL_CAT_GRP:
        return <DeleteCategoryGroup onSave={props.onSave} data={props.data} onClose={props.onClose}/>
      case REDLINE_DIALOG_OPTIONS.ADD_NEW_DATASET:
        return <AddNewDatasetDialogContent action={props.action} onClose={props.onClose}/>;
      case REDLINE_DIALOG_OPTIONS.DELETE:
        return <DeleteFolderDialogContent treeType={props.treeType} isdataset={props.isdataset} action={props.action} onClose={props.onClose}
                                          data={{contextNodeId: props.contextNodeId, contextTreeId: props.contextTreeId, ...props.data}} dialogtitle={props.dialogtitle} treeData={props?.treeData}/>;
      case REDLINE_DIALOG_OPTIONS.ADD_NEW_FOLDER:
        return <AddNewFolderDialogContent action={props.action} onClose={props.onClose}/>;
      case REDLINE_DIALOG_OPTIONS.EDIT_FOLDER:
        return <AddNewFolderDialogContent action={props.action} onClose={props.onClose} dialogType={TREE_OPERATIONS.EDIT} treeData={props?.treeData} contextNodeId={props?.contextNodeId}/>;
      case REDLINE_DIALOG_OPTIONS.ADD_PROPERTY:
        return <AddPropertyDialog onSave={props.onSave} propertyType={props.propertyType} title={props.dialogtitle} multipleSelect={props.multipleSelect} data={props.data} onClose={props.onClose}/>
      case REDLINE_DIALOG_OPTIONS.EDIT_DATASET:
        return <AddNewDatasetDialogContent
          treeData={props?.treeData}
          dialogType={TREE_OPERATIONS.EDIT_DATASET}
          action={props.action}
          onClose={props.onClose}
          contextNodeId={props?.contextNodeId}
        />
      case REDLINE_DIALOG_OPTIONS.EDIT_MERGE_SET:
        return <EditMergeSet mergeSetId={props?.contextNodeId} onClose={props.onClose}/>
      case REDLINE_DIALOG_OPTIONS.EDIT_PROPERTY:
        return <EditPropertyDialog onSave={props.onSave} propertyType={props.propertyType} title={props.dialogtitle} data={props.data} onClose={props.onClose}/>
      case REDLINE_DIALOG_OPTIONS.EDIT_ROW:
        return <EditDrivingScenarioRowDialog handleRowChange={props.handleRowChange} dialogtitle={props.dialogtitle} data={props.oldRowData} onClose={props.onClose}/>
      case REDLINE_DIALOG_OPTIONS.DUPLICATE_DATASET:
        return <DuplicateDatasetDialog
          action={props.action}
          onClose={props.onClose}
          data={{contextNodeId: props.contextNodeId, contextTreeId: props.contextTreeId}}
          treeData={props?.treeData}
          contextNodeId={props?.contextNodeId}
        />
    }
  }


  return (<>
    <StyledArgosDialog width={"auto"} maxWidth={'95vw'} height={"fit-content"} {...props} open={props.open} onClose={() => {
    }}>
      <div style={{display: 'flex', flexDirection: 'column', height: '100%', overflow: 'auto'}}>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <div>
            <ArgosDialogHeader>
              <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography sx={{color: 'white', fontSize: 14}}>{props.dialogtitle}</Typography>
                <IconButton onClick={props.onClose} sx={{color: 'white', padding: 0, fontSize: 'small'}}>
                  <CloseIcon/>
                </IconButton>
              </ArgosFlexbox>
            </ArgosDialogHeader>
          </div>
        </div>
        <div style={{overflow: 'auto', display: 'flex', flexDirection: 'column', padding: 10, flex: 1}}>
          {generateDialogBasedOnType()}
        </div>
      </div>
    </StyledArgosDialog>
  </>
)
}
export default RedlineAppDialog;
